module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Book-open-bc5160d2e483482640d654e6a6d58c91.svg";